import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ContractForm from "../../components/Contract/ContractForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ContractEdit = ({classes, contract, buildings ,uploadConfig}) => {

    let title = i18n.get('contract.add');
    if(contract.id) {
        title = i18n.get('contract.edit');
    }

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={title}
            />
            <Card>
                <CardContent>
                    <ContractForm
                        values={{...contract, buildings} || {}}
                        uploadConfig={uploadConfig}
                    />
                </CardContent>
            </Card>
        </Layout>
    )
};

export default ContractEdit;
